import { Injectable } from '@angular/core';
import { transform } from '@services/map';
import { WindowOpenerService } from '@services/window-opener/window-opener.service';
import { Destination } from '../../schema/destination';
import { INavigationProvider } from '../../schema/interfaces/INavigationProvider';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsProviderService implements INavigationProvider {
  protected readonly WSG84_EPSG = '4326';

  constructor(private windowOpenerService: WindowOpenerService) {}

  navigateTo(destination: Destination) {
    this.transformDestination(destination);
    this.windowOpenerService.system(
      `https://www.google.com/maps/dir/?api=1&destination=${destination.location.y},${destination.location.x}`
    );
  }

  protected transformDestination(destination: Destination, providerEPSG: string = this.WSG84_EPSG) {
    if (destination.location.epsg !== providerEPSG) {
      destination.location = transform(destination.location, `EPSG:${providerEPSG}`);
    }
  }
}
